// extracted by mini-css-extract-plugin
export default {"box":"orderPage_box__FV24g"};